var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "risk-scale" }, [
    _vm.hasScore
      ? _c(
          "div",
          { staticClass: "risk-scale__active", style: _vm.activeStyle },
          [
            _c(
              "div",
              { staticClass: "risk-scale__marker", style: _vm.markerStyle },
              [_c("div", { staticClass: "risk-scale__marker-inner" })]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }